<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title16"></a><div class="title-toc">Table of Contents</div>
<div class="toc_entry"><span class="toc_entry_titlePage" href="#/e9780312964139_tp01" id="toctitle14" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<a class="toc_entry_frontMatter" href="#/e9780312964139_fm01" id="toctitle1"><span><strong class="b">PROLOGUE</strong></span></a><br/><br/>
<a class="toc_entry_chapter" href="#/e9780312964139_c01" id="toctitle2"><span><strong class="b">ONE</strong> - <strong class="b">THE DAWN</strong></span></a><br/>
<a class="toc_entry_chapter" href="#/e9780312964139_c02" id="toctitle3"><span><strong class="b">TWO</strong> - <strong class="b">THE BULLET</strong></span></a><br/>
<span class="toc_entry_chapter" href="#/e9780312964139_c03" id="toctitle4" title="Link target outside of Sample"><span><strong class="b">THREE</strong> - <strong class="b">THE SELECTION</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9780312964139_c04" id="toctitle5" title="Link target outside of Sample"><span><strong class="b">FOUR</strong> - <strong class="b">THE TRAINING</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9780312964139_c05" id="toctitle6" title="Link target outside of Sample"><span><strong class="b">FlVE</strong> - <strong class="b">THE CHANGELING</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9780312964139_c06" id="toctitle7" title="Link target outside of Sample"><span><strong class="b">SIX</strong> - <strong class="b">THE DECISION</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9780312964139_c07" id="toctitle8" title="Link target outside of Sample"><span><strong class="b">SEVEN</strong> - <strong class="b">THE FALL</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9780312964139_c08" id="toctitle9" title="Link target outside of Sample"><span><strong class="b">EIGHT</strong> - <strong class="b">THE REBIRTH</strong></span></span><br/><br/>
<span class="toc_entry_backMatter" href="#/e9780312964139_bm01" id="toctitle10" title="Link target outside of Sample"><span><strong class="b">EPILOGUE</strong></span></span><br/>
<span class="toc_entry_frontMatter" href="#/e9780312964139_fm02" id="toctitle11" title="Link target outside of Sample"><span><strong class="b">AUTHOR’S NOTE</strong></span></span><br/>
<span class="toc_entry_frontMatter" href="#/e9780312964139_fm03" id="toctitle12" title="Link target outside of Sample"><span><strong class="b">“YOUR LIFE WILL NEVER BE THE SAME.”</strong></span></span><br/>
<span class="toc_entry_backMatter" href="#/e9780312964139_bm02" id="toctitle13" title="Link target outside of Sample"><span><strong class="b">POINTS OF DEPARTURE</strong></span></span><br/>
<span class="toc_entry_footnotes" href="#/e9780312964139_ftn01" id="toctitle18" title="Link target outside of Sample"><span>Notes</span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9780312964139_cop01" id="toctitle15" title="Link target outside of Sample"><span>Copyright Page</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780312964139_toc01.vue?d1600248